<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            label="비용발생기간"
            :range="true"
            defaultStart="-6M"
            defaultEnd="0M"
            name="period"
            type="month"
            v-model="period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            type="search"
            label="사고자부서"
            name="deptCd"
            :isFirstValue="false"
            v-model="searchParam.deptCd"
          >
          </c-dept>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="search"
            :comboItems="typeItems"
            itemText="codeName"
            itemValue="code"
            label="공상/산재"
            name="accidentType"
            v-model="searchParam.accidentType"
          >
          </c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사고자 -->
          <c-field
            label="사고자"
            v-model="searchParam.accidentUserId"
          ></c-field>
        </div>
      </template>
    </c-search-box>
    <!-- 연간 예산편성 목록 -->
    <c-table
      ref="table"
      title="월별 손실비용 현황"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :data="grid.data"
      :columnSetting="false"
      :expandAll="true"
      :merge="grid.merge"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <!-- 등록 -->
          <!-- <c-btn label="LBLREG" v-if="editable" icon="add" @btnClicked="linkClick" /> -->
          <!-- 검색 -->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
      <template v-slot:customBottomRow>
        <q-tr
          v-if="grid.data && grid.data.length > 0"
          no-hover
          class="table-bottom-fixed"
        >
          <q-td
            class="text-center th-td-style th-style"
            :rowspan="1"
            :colspan="1"
          >
          </q-td>
          <q-td
            class="text-center th-td-style th-style"
            :rowspan="1"
            :colspan="1"
          >
          </q-td>
          <q-td
            class="text-center th-td-style th-style"
            :rowspan="1"
            :colspan="1"
          >
          </q-td>
          <q-td
            class="text-center th-td-style th-style"
            :rowspan="1"
            :colspan="1"
          >
          </q-td>
          <q-td
            class="text-center th-td-style th-style"
            :rowspan="1"
            :colspan="1"
          >
          </q-td>
          <q-td
            class="text-center th-td-style th-style"
            :rowspan="1"
            :colspan="1"
            >합계
          </q-td>
          <q-td
            class="text-right th-td-style th-style"
            :rowspan="1"
            :colspan="1"
          >
            <span>
              {{ $_.sumBy(grid.data, "hospitalCost") | toThousandFilter }}
            </span>
          </q-td>
          <q-td
            class="text-right th-td-style th-style"
            :rowspan="1"
            :colspan="1"
          >
            <span>
              {{ $_.sumBy(grid.data, "costlossCost") | toThousandFilter }}
            </span>
          </q-td>
          <q-td
            class="text-right th-td-style th-style"
            :rowspan="1"
            :colspan="1"
          >
            <span>
              {{ $_.sumBy(grid.data, "sanjaeCost") | toThousandFilter }}
            </span>
          </q-td>
          <q-td
            class="text-right th-td-style th-style"
            :rowspan="1"
            :colspan="1"
          >
            <span>
              {{ $_.sumBy(grid.data, "wage") | toThousandFilter }}
            </span>
          </q-td>
          <q-td
            class="text-right th-td-style th-style"
            :rowspan="1"
            :colspan="1"
          >
            <span>
              {{ $_.sumBy(grid.data, "costlossCostTotal") | toThousandFilter }}
            </span>
          </q-td>
        </q-tr>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "costloss-month-manage",
  data() {
    return {
      typeItems: [
        { code: "공상", codeName: "공상" },
        { code: "산재", codeName: "산재" },
      ],
      grid: {
        merge: [
          { index: 0, colName: "statYear" },
          { index: 1, colName: "mergeMonth" },
          { index: 2, colName: "mergeUser" },
          { index: 3, colName: "mergeUser" },
        ],
        columns: [
          {
            name: "statYear",
            field: "statYear",
            label: "년도",
            style: "width:100px",
            align: "center",
            sortable: true,
          },
          {
            name: "statMonth",
            field: "statMonth",
            label: "월",
            style: "width:100px",
            align: "center",
            sortable: true,
          },
          {
            name: "deptName",
            field: "deptName",
            label: "부서",
            align: "center",
            style: "width:140px",
            sortable: true,
          },
          {
            name: "accidentUserName",
            field: "accidentUserName",
            label: "재해자",
            align: "center",
            style: "width:90px",
            sortable: true,
          },
          {
            name: "accidentName",
            field: "accidentName",
            label: "재해명",
            align: "left",
            type: "link",
            sortable: true,
          },
          {
            name: "occurrenceDate",
            field: "occurrenceDate",
            style: "width:130px",
            label: "재해일시",
            align: "center",
            sortable: true,
          },
          {
            name: "hospitalCost",
            field: "hospitalCost",
            label: "병원진료비",
            type: "cost",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "costlossCost",
            field: "costlossCost",
            label: "근로손실비",
            style: "width:140px",
            sortable: true,
            type: "linkcost",
          },
          {
            name: "sanjaeCost",
            field: "sanjaeCost",
            label: "산재생계보조금",
            style: "width:120px",
            sortable: true,
            type: "cost",
          },
          {
            name: "wage",
            field: "wage",
            label: "장해보상금",
            type: "cost",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "costlossCostTotal",
            field: "costlossCostTotal",
            label: "합계",
            style: "width:120px",
            type: "cost",
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        startYmd: "",
        endYmd: "",
        deptCd: "",
        accidentUserId: "",
        accidentTypeCd: null,
        accidentType: null,
      },
      editable: true,
      listUrl: "",
      detailUrl: "",
      period: [],
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.sai.costloss.monthlist.url;
      this.detailUrl = selectConfig.sai.costloss.get.url;
      this.getList();
    },
    getList() {
      if (this.period && this.period.length > 1) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = "";
        this.searchParam.endYmd = "";
      }
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      if (col.name == "accidentName") {
        this.popupOptions.title = "사고 상세";
        this.popupOptions.param = {
          iimAccidentId: row ? row.iimAccidentId : "",
          stepCd: row ? row.accidentStatusCd : "",
        };
        this.popupOptions.target = () =>
          import(`${"@/pages/sop/iim/processAccidentDetail.vue"}`);
        this.popupOptions.visible = true;
        this.popupOptions.isFull = true;
        this.popupOptions.closeCallback = this.closePopup;
      } else if (col.name == "costlossCost") {
        this.popupOptions.title = "HR 월별 임금정보";
        this.popupOptions.param = {
          iimAccidentId: row ? row.iimAccidentId : "",
          hyponMonth: row ? row.hyponMonth : "",
        };
        this.popupOptions.target = () =>
          import(`${"@/pages/sai/costloss/costlossManageDetail.vue"}`);
        this.popupOptions.width = "70%";
        this.popupOptions.visible = true;
        this.popupOptions.isFull = false;
        this.popupOptions.closeCallback = this.closePopup;
      }
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
